import React from "react";
import down from "../../../assets/down-white.png";
import "./NumberInputStyles.scss";

interface NumberInputProps {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
  setCoversOpen: () => void;
  newReservation?: boolean;
  onChange: () => void;
}

const NumberInput: React.FC<NumberInputProps> = ({
  value,
  setValue,
  setCoversOpen,
  newReservation,
  onChange,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputVal = e.target.value;

    if (inputVal === "") {
      setValue(0);
      return;
    }

    let num = Number(inputVal);

    if (isNaN(num)) return;

    if (num < 1) num = 1;
    if (num > 100) num = 100;

    setValue(num);
    onChange();
  };

  const increase = () => {
    if (value < 25) {
      setValue((prev) => prev + 1);
      onChange();
    }
  };

  const decrease = () => {
    if (value > 1) {
      setValue((prev) => prev - 1);
      onChange();
    }
  };

  return (
    <div
      className='NumberInput'
      style={{ border: newReservation ? "none" : undefined }}
    >
      <div className='numb-cont' onClick={setCoversOpen}>
        {newReservation ? (
          <input
            type='number'
            value={value === 0 ? "" : value}
            onChange={handleInputChange}
            max={100}
            min={1}
          />
        ) : (
          value
        )}
      </div>
      <div className='arrow-cont-in'>
        <div className='cont' onClick={increase}>
          <img alt='' src={down} className='image rotate-up' />
        </div>
        <div className='cont-2' onClick={decrease}>
          <img alt='' src={down} className='image' />
        </div>
      </div>
    </div>
  );
};

export default NumberInput;
